import styled from "styled-components";

export const HistoryRecordGameNameBox = styled.div`
    flex-grow: 1;
    font-weight: bold;
    ${({theme}) => theme.font.presets.bold};

`